// ProvenanceSection — the signature element of artist Resource pages.
// Takes a confidence value ('high' | 'med' | 'low') and renders the colored
// rail, the outlined badge pill, and the editor's-note footer.
//
// Confidence markers must stay structurally distinct from collection-status
// markers: thin vertical rails and OUTLINED pills here — never the filled
// dots and solid chips that mean Collected / Wishlist / Trade / For Sale.

const CONF = {
  high: { color: 'var(--green)', label: 'Verified' },
  // No pill for 'med': the gold rail and the editor's note carry it on a published page.
  med: { color: 'var(--gold)', label: '' },
  low: { color: 'var(--red-2)', label: 'Unconfirmed — do not treat as fact' },
};
const NEUTRAL = '#5c6a80';

export default function ProvenanceSection({ id, title, confidence, badge, editorNote, children }) {
  const conf = CONF[confidence];
  const railColor = conf ? conf.color : NEUTRAL;
  const badgeText = badge || (conf ? conf.label : '');

  return (
    <section id={id} style={{ position: 'relative', padding: '44px 0 40px', paddingLeft: 'clamp(20px, 4vw, 40px)' }}>
      <div
        aria-hidden="true"
        style={{
          position: 'absolute', left: 0, top: 46, bottom: 34, width: 3,
          borderRadius: 2, background: railColor, opacity: 0.85,
        }}
      />
      <div className="ap-clear-nav" style={{ display: 'flex', alignItems: 'baseline', gap: 14, flexWrap: 'wrap', marginBottom: 6 }}>
        <h2 style={{
          fontFamily: "'Orbitron', monospace", textTransform: 'uppercase', letterSpacing: '0.02em',
          fontSize: 'clamp(18px, 2.6vw, 25px)', fontWeight: 700, color: '#fff', margin: 0,
        }}>
          {title}
        </h2>
        {badgeText && (
          <span style={{
            fontFamily: "'Share Tech Mono', monospace", fontSize: 10, letterSpacing: '0.16em',
            textTransform: 'uppercase', padding: '3px 9px', borderRadius: 2,
            border: `1px solid ${railColor}`, color: railColor, whiteSpace: 'nowrap',
          }}>
            {badgeText}
          </span>
        )}
      </div>
      {children}
      {editorNote && (
        <div style={{
          fontFamily: "'Share Tech Mono', monospace", fontSize: 11.5, letterSpacing: '0.04em',
          lineHeight: 1.7, color: NEUTRAL, maxWidth: '78ch', marginTop: 18,
          borderTop: '1px dashed rgba(var(--wash-rgb),0.07)', paddingTop: 12,
        }}>
          EDITOR'S NOTE — {editorNote}
        </div>
      )}
    </section>
  );
}
